<script lang="ts">
	import { serializeJsonLd } from './jsonLd';

	// Ein einzelnes JSON-LD-Objekt oder mehrere; jedes wird als eigenes
	// <script type="application/ld+json"> in den <head> gerendert.
	let { data }: { data: unknown | unknown[] } = $props();

	const items = $derived(Array.isArray(data) ? data : [data]);
</script>

<svelte:head>
	{#each items as item}
		{@html `<script type="application/ld+json">${serializeJsonLd(item)}<\/script>`}
	{/each}
</svelte:head>
